export default {
  TakeInteractiveTour: 1,
  UnderstandPricingPlan: 2,
  ClearDemoData: 3,
  StoreIntegration: 4,
  ConfigureProductPreference: 5,
  ConfigureShippingPreference: 6,
  SendInventory: 7,
  ConfigureBilling: 8,
  AddYourProducts: 9,
  ImportOrders: 10,
  KYC: 11
}
